/* import __COLOCATED_TEMPLATE__ from './address-with-validation.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _updateAddress, _validateAddress;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { assertNonNullable } from '@banking/ui/utils/assert';
import { FieldIdentifier } from '@banking/ui/models/common/address';
import { GlobalAddress } from '@square/dashboard-protos/models/squareup/common/location';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { lgtmValidate } from '@banking/ui/utils/validator/lgtm-validate';
import globalAddressValidator from '@banking/ui/utils/validator/global-address-validator';
let AddressWithValidation = (_dec = computed('validation.errors.addressLine1.length'), _dec2 = computed('validation.errors.postalCode.length'), _dec3 = computed('validation.errors.administrativeDistrictLevel1.length'), _dec4 = computed('validation.errors.locality.length'), (_class = (_updateAddress = /*#__PURE__*/new WeakSet(), _validateAddress = /*#__PURE__*/new WeakSet(), class AddressWithValidation extends Component {
  constructor(...args) {
    super(...args);
    _classPrivateMethodInitSpec(this, _validateAddress);
    _classPrivateMethodInitSpec(this, _updateAddress);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "_address", _descriptor2, this);
    _initializerDefineProperty(this, "validation", _descriptor3, this);
    _initializerDefineProperty(this, "liveValidate", _descriptor4, this);
    // "static" properties
    _defineProperty(this, "FieldIdentifier", FieldIdentifier);
  }
  get addressLineOneErrorMessage() {
    return this.validation.errors.addressLine1.length > 0 ? this.validation.errors.addressLine1[0] : undefined;
  }
  get postalCodeErrorMessage() {
    return this.validation.errors.postalCode.length > 0 ? this.validation.errors.postalCode[0] : undefined;
  }
  get administrativeAreaErrorMessage() {
    return this.validation.errors.administrativeDistrictLevel1?.length > 0 ? this.validation.errors.administrativeDistrictLevel1[0] : undefined;
  }
  get localityErrorMessage() {
    return this.validation.errors.locality.length > 0 ? this.validation.errors.locality[0] : undefined;
  }
  async onValueChange(field, value) {
    this._address = _classPrivateMethodGet(this, _updateAddress, _updateAddress2).call(this, this._address, field, value);
    if (this.liveValidate) {
      this.validation = await _classPrivateMethodGet(this, _validateAddress, _validateAddress2).call(this, this._address);
    }
    this.args.onValueChange(this._address);
  }
  async onClick() {
    this.liveValidate = true;
    this.validation = await _classPrivateMethodGet(this, _validateAddress, _validateAddress2).call(this, this._address);
    this.args.onClick(this._address, this.validation.valid);
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_address", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.address;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "validation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {
      errors: {
        addressLine1: [],
        administrativeDistrictLevel1: [],
        locality: [],
        postalCode: []
      },
      valid: true
    };
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "liveValidate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "addressLineOneErrorMessage", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "addressLineOneErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "postalCodeErrorMessage", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "postalCodeErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "administrativeAreaErrorMessage", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "administrativeAreaErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "localityErrorMessage", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "localityErrorMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onValueChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onValueChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class));
function _updateAddress2(address, field, value) {
  const addressRecord = address.toJSON();
  switch (field) {
    case FieldIdentifier.ADDRESS_LINE_1:
      {
        addressRecord.addressLine1 = value;
        break;
      }
    case FieldIdentifier.ADDRESS_LINE_2:
      {
        addressRecord.addressLine2 = value;
        break;
      }
    case FieldIdentifier.POSTAL_CODE:
      {
        addressRecord.postalCode = value;
        break;
      }
    case FieldIdentifier.ADMINISTRATIVE_AREA:
      {
        addressRecord.administrativeDistrictLevel1 = value;
        break;
      }
    case FieldIdentifier.LOCALITY:
      {
        addressRecord.locality = value;
        break;
      }
  }
  return GlobalAddress.fromObject(addressRecord);
}
function _validateAddress2(address) {
  const countryCode = assertNonNullable(this.args.countryAddressData.countryCode);
  const validator = lgtmValidate(globalAddressValidator(Country[countryCode], key => this.intl.t(key)));
  return validator(address);
}
export { AddressWithValidation as default };